import firebase from "../../firebase";

export default function({ officeId, stageId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "setDefaultStage",
        data: {
            officeId,
            stageId
        }
    });
}
